import { createReducer, on } from '@ngrx/store';
import { loadCurrentUserSuccess } from './currentUser.actions';
import { TokenUser } from '@shared';

export interface CurrentUserState {
  currentUser: TokenUser;
}

export const initialState: CurrentUserState = {
  currentUser: { _id: '', email: '' },
};

const _currentUserReducer = createReducer(
  initialState,
  on(loadCurrentUserSuccess, (state, { currentUser }) => ({ ...state, currentUser })),
);

export function currentUserReducer(state: CurrentUserState | undefined, action: any) {
  return _currentUserReducer(state, action);
}
